import React, { useEffect } from 'react';
import { FaBullseye, FaHandshake, FaChartLine } from 'react-icons/fa';
import '../styles/global.css'; // Ensure this import is present for styles

function AboutUs() {
  useEffect(() => {
    const sections = document.querySelectorAll('.about-section');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in-active');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    sections.forEach((section) => observer.observe(section));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="container mx-auto px-4 py-16">
      {/* Hero Section */}
      <section
        className="hero-section relative h-80 flex flex-col justify-center items-center text-center text-white"
        style={{
          background: 'linear-gradient(to right, #1f2937, #111827)', // Matching the Home page gradient
          color: 'white',
        }}
      >
        <div className="bg-black bg-opacity-50 absolute inset-0"></div>
        <h1 className="relative text-5xl font-bold z-10">About CrossTax Advisors</h1>
        <p className="relative text-lg mt-4 z-10 max-w-2xl">
          Bringing Big 4 expertise to deliver seamless cross-border tax solutions that empower businesses and individuals.
        </p>
      </section>

      {/* Company Vision and Values */}
      <section className="about-section mt-16 p-8 bg-gray-50 rounded-lg shadow-lg fade-in">
        <h2 className="text-3xl font-semibold mb-6 text-gray-900">Our Vision & Values</h2>
        <div className="grid md:grid-cols-2 gap-8">
          <div>
            <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center">
              <FaBullseye className="text-accent mr-2" /> Our Mission
            </h3>
            <p className="text-lg text-gray-700 mb-4">
              To redefine cross-border tax advisory with precision, transparency, and a client-centric approach, ensuring seamless tax solutions for US-India interactions.
            </p>
          </div>
          <div>
            <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center">
              <FaHandshake className="text-accent mr-2" /> Our Core Values
            </h3>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>Client-first approach with a dedication to quality service</li>
              <li>Innovation in tax strategies and technology-driven solutions</li>
              <li>Ethical practices and transparency in all engagements</li>
              <li>Commitment to long-term growth and partnership</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Milestones or Journey Section */}
      <section className="about-section mt-16 fade-in">
        <h2 className="text-3xl font-semibold mb-6 text-gray-900">Our Journey</h2>
        <div className="timeline-container space-y-8">
          <div className="timeline-item">
            <h3 className="text-xl font-semibold text-gray-800">2022</h3>
            <p className="text-lg text-gray-700">Founded with a mission to bring Big 4 expertise to cross-border tax advisory.</p>
          </div>
          <div className="timeline-item">
            <h3 className="text-xl font-semibold text-gray-800">2023</h3>
            <p className="text-lg text-gray-700">Expanded service offerings to include real estate and high-net-worth individual tax structuring.</p>
          </div>
          {/* Add more milestones as needed */}
        </div>
      </section>

      {/* Founder's Message */}
      <section className="about-section mt-16 p-8 bg-gray-50 rounded-lg shadow-lg fade-in">
        <h2 className="text-3xl font-semibold mb-6 text-gray-900">A Message from Our Founder</h2>
        <p className="text-lg text-gray-700 mb-4">
          "At CrossTax Advisors, our goal is to simplify complex tax processes and provide clients with the clarity and confidence they need in today’s fast-paced, globalized economy. We’re dedicated to building long-term relationships and delivering results that matter."
        </p>
        <p className="text-right font-semibold text-gray-800">– [Founder's Name]</p>
      </section>

      {/* Call to Action */}
      <div className="text-center mt-16">
        <button className="btn-primary px-8 py-3 bg-accent text-white font-semibold rounded-full hover:bg-blue-600 hover:scale-105 hover:shadow-lg transition transform duration-300">
          Learn More About Our Team
        </button>
      </div>
    </div>
  );
}

export default AboutUs;
